import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d65d649c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "acLang_label" }
const _hoisted_2 = { class: "acLang_selected" }
const _hoisted_3 = { class: "acLang_icon" }
const _hoisted_4 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12.0007 10.5865L16.2433 6.34384C16.6338 5.95331 17.267 5.95331 17.6575 6.34383C18.048 6.73435 18.048 7.36751 17.6575 7.75803L13.4149 12.0007L17.6575 16.2433C18.048 16.6338 18.048 17.267 17.6575 17.6575C17.267 18.048 16.6338 18.048 16.2433 17.6575L12.0007 13.4149L7.75803 17.6575C7.36751 18.048 6.73435 18.048 6.34383 17.6575C5.95331 17.267 5.95331 16.6338 6.34384 16.2433L10.5865 12.0007L6.34382 7.75803C5.9533 7.36751 5.9533 6.73435 6.34382 6.34382C6.73435 5.9533 7.36751 5.9533 7.75803 6.34382L12.0007 10.5865Z",
  fill: "#0E2242"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2707_73290)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.828 12.0007L15.071 16.2437C15.4615 16.6342 15.4615 17.2673 15.071 17.6577C14.6805 18.0482 14.0475 18.0482 13.657 17.6577L8.48954 12.4903C8.21917 12.2199 8.21917 11.7815 8.48954 11.5112L13.657 6.34372C14.0475 5.95325 14.6805 5.95325 15.071 6.34372C15.4615 6.73418 15.4615 7.36725 15.071 7.75772L10.828 12.0007Z",
    fill: "#2170FB"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2707_73290" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "24",
      height: "24",
      fill: "white"
    })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "acLang_block"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "lang_title" }
const _hoisted_14 = {
  key: 0,
  class: "lang_selected"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "11",
  viewBox: "0 0 15 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.91707 8.01119L13.1941 0.733398L14.3143 1.85282L5.91707 10.25L0.878906 5.21186L1.99832 4.09244L5.91707 8.01119Z",
    fill: "#3C92FE"
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["acLang", {
      '-visibleBlock': _ctx.showBlock
    }])
  }, [
    _createElementVNode("div", {
      class: "acLang_input",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToggleBlock && _ctx.onToggleBlock(...args)))
    }, [
      _renderSlot(_ctx.$slots, "label", {}, () => [
        _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t('lang')), 1)
      ], true),
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.selectedLang) + " ", 1),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.showBlock)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
            : (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
        ])
      ])
    ]),
    (_ctx.showBlock)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLang, (item, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              onClick: ($event: any) => (_ctx.setLang(key)),
              class: "acLang_item lang"
            }, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(item), 1),
              (item === _ctx.selectedLang)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                : _createCommentVNode("", true)
            ], 8, _hoisted_12))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}